// extracted by mini-css-extract-plugin
export default {"section":"Facilities_section__vaCQk","heading":"Facilities_heading__CxVTh","card":"Facilities_card__IJi0A","cardImg":"Facilities_cardImg__C470+","label":"Facilities_label__WVD+T"};